import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { base44 } from "@/api/base44Client";
import { useApp } from "@/lib/AppContext";

export default function OfferBanners() {
  const { lang } = useApp();
  const isAr = lang === "ar";
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    base44.entities.OfferBanner.filter({ is_active: true }, "sort_order", 10)
      .then(setBanners).catch(() => {});
  }, []);

  if (banners.length === 0) return null;

  return (
    <section className="pt-2 pb-8 sm:py-8 bg-background" dir={isAr ? "rtl" : "ltr"}>
      <div className="max-w-6xl mx-auto px-4">
        <div className={`grid gap-2.5 sm:gap-4 ${banners.length === 1 ? "grid-cols-1" : "grid-cols-2"}`}>
          {banners.map(b => {
            const title = isAr ? b.title : (b.title_en || b.title);
            const subtitle = isAr ? b.subtitle : (b.subtitle_en || b.subtitle);
            const badge = isAr ? b.badge_text : (b.badge_text_en || b.badge_text);
            const btnText = isAr ? (b.button_text || "اطلب الآن") : (b.button_text_en || "Order Now");
            const link = b.button_link || "/laundry";
            const isInternal = link.startsWith("/");
            const gradient = b.bg_gradient || "from-[#1E5FA8] to-[#0e3060]";

            const CardWrapper = ({ children }) =>
              isInternal ? (
                <Link to={link} className="block">{children}</Link>
              ) : (
                <a href={link} target="_blank" rel="noopener noreferrer" className="block">{children}</a>
              );

            return (
              <CardWrapper key={b.id}>
                <div className={`relative overflow-hidden rounded-2xl sm:rounded-3xl bg-gradient-to-br ${gradient} p-3 sm:p-6 shadow-xl hover:shadow-2xl hover:scale-[1.02] transition-all duration-300 min-h-[140px] sm:min-h-[180px] flex items-center`}>
                  {/* Decorative circles */}
                  <div className="absolute top-0 end-0 w-20 h-20 sm:w-28 sm:h-28 bg-white/5 rounded-full -translate-y-1/3 translate-x-1/3" />
                  <div className="absolute bottom-0 start-0 w-14 h-14 sm:w-20 sm:h-20 bg-white/5 rounded-full translate-y-1/3" />

                  {/* Content */}
                  <div className="relative z-10 flex-1 min-w-0">
                    {badge && (
                      <p className="text-white/80 text-[10px] sm:text-xs font-bold mb-1 truncate">{badge}</p>
                    )}
                    <h3 className="text-white font-black text-base sm:text-3xl leading-tight mb-0.5 sm:mb-1">
                      {title}
                    </h3>
                    {subtitle && (
                      <p className="text-white/70 text-[11px] sm:text-sm font-medium mb-2 sm:mb-4 line-clamp-1 sm:line-clamp-none">{subtitle}</p>
                    )}
                    <span className="inline-flex items-center gap-1 bg-white text-slate-800 font-black text-[11px] sm:text-sm px-3 py-1.5 sm:px-5 sm:py-2.5 rounded-full shadow-lg hover:opacity-90 transition-opacity">
                      {btnText} 🛒
                    </span>
                  </div>

                  {/* Icon */}
                  {b.icon && (
                    <div className="relative z-10 flex-shrink-0 ps-2 sm:ps-4">
                      <div className="w-12 h-12 sm:w-24 sm:h-24 rounded-2xl sm:rounded-3xl bg-white/10 backdrop-blur-sm flex items-center justify-center text-2xl sm:text-6xl shadow-inner">
                        {b.icon}
                      </div>
                    </div>
                  )}
                </div>
              </CardWrapper>
            );
          })}
        </div>
      </div>
    </section>
  );
}